import { cfg } from "../../configuracion";

const saveResidente = async (datos, idioma, token) => {
  try {
    const url = `${cfg.apiUrl}/residente`;
    const datosParaEnviar = {...datos, clave: datos.clave };
    
    const resp = await fetch(url, {
      method: "POST",
      headers: {
        "Accept-Language": idioma,
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,

        // Deshabilitar provisionalmente la caché
        "Cache-Control": "no-cache, no-store, must-revalidate",
        Pragma: "no-cache",
        Expires: "0"
      },
      body: JSON.stringify(datosParaEnviar),
    });

    if (!resp.ok) {
      const errorData = await resp.json();
      throw new Error(errorData.mensaje || `Error ${resp.status}: ${resp.statusText}`);
    }

    const data = await resp.json();
    if (!data.ok || !data.datos) {
      throw new Error(data.mensaje || 'Error desconocido');
    }

    const documentos = Object.values(data.datos);
    return documentos;
  } catch (error) {
    throw error;
  }
};

export default saveResidente;
